import React, {useContext, useEffect} from 'react';
import ErrorContext from "../../contexts/error/ErrorContext";


export default function UnexpectedApp() {

    const errorContext = useContext(ErrorContext);

    useEffect(() => {
        errorContext.setError('Unexpected');
    }, []);

    return null;
}
